import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Seo } from "../lib/seo";
import { Reveal } from "../lib/motion";
import { BreakCard } from "../components/BreakCard";

export default function Breaks() {
  const [breaks, setBreaks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/breaks").then((r) => setBreaks(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <main className="container-tpb py-14 sm:py-20" data-testid="breaks-listing-page">
      <Seo
        title="All Perfect Breaks | UK Short Breaks for Adults from £169 for two"
        description="Browse every Perfect Break: hand-picked hotels, breakfast and three experiences included, from £169 for two. Weekend and midweek breaks across the Heart of England."
        path="/breaks"
      />
      <p className="overline">All breaks</p>
      <div className="mt-3">
        <h1 className="text-4xl font-medium tracking-tight sm:text-5xl" data-testid="breaks-heading">Every Perfect Break</h1>
        <p className="mt-3 text-ink-muted" data-testid="breaks-count">
          {breaks.length} break{breaks.length === 1 ? "" : "s"} · hotel, breakfast &amp; 3 experiences · from £169 for two
        </p>
      </div>

      <div className="mt-12 grid gap-x-8 gap-y-14 sm:grid-cols-2" data-testid="breaks-grid">
        {breaks.map((b, i) => <BreakCard key={b.slug} brk={b} index={i} />)}
      </div>
      {!loading && breaks.length === 0 && (
        <div className="mt-16 rounded-lg border border-sandline bg-white p-12 text-center" data-testid="no-results">
          <p className="font-serif text-2xl text-ink">New breaks are on their way.</p>
          <p className="mt-2 text-ink-muted">Join the list on the homepage and be first to hear.</p>
        </div>
      )}

      <Reveal>
        <aside className="mt-16 rounded-lg border border-sandline bg-sand-dark p-8" data-testid="listing-value-strip">
          <h2 className="font-serif text-2xl font-semibold text-primary">Why book a package instead of DIY?</h2>
          <p className="mt-3 max-w-3xl leading-relaxed text-ink-muted">
            Book the same hotel and three experiences separately and you'll spend the evening juggling tabs, times and terms — usually for more money. A Perfect Break bundles it all into one price for two, with experiences you'd never have found alone. Less admin, more away.
          </p>
        </aside>
      </Reveal>
    </main>
  );
}
